// Figma: no frame provided yet — built using the established design system per the
// "extrapolate" decision (see ../Engagement/EngagementSection.js for the closest precedent).
// LOGIC PORTED verbatim from LC2's PerformanceTab.js (commons/components/HomeTabs/
// Performance/PerformanceTab.js): switches on the same `openItem` menu-reducer value
// (set by MainLayout.js off the URL — 'campaigns' when a campaign is selected, 'communities'
// when a community is selected, 'portfolio' otherwise) to pick which of the three
// account/community/campaign-level Performance components to render.
import React from 'react';
import {useSelector} from 'react-redux';

import {getOpenItem} from '../../../app/store/reducers/menu';
import AccountPerformance from './AccountPerformance';
import CommunityPerformance from './CommunityPerformance';
import CampaignPerformance from './CampaignPerformance';

const PerformanceSection = () => {
    const openItem = useSelector(getOpenItem);

    switch (openItem) {
        case 'campaigns':
            return <CampaignPerformance />;
        case 'communities':
            return <CommunityPerformance />;
        case 'portfolio':
            return <AccountPerformance />;
        default:
            return null;
    }
};

export default PerformanceSection;
